import { render, staticRenderFns } from "./LikeIcon.vue?vue&type=template&id=39e0b733"
import script from "./LikeIcon.vue?vue&type=script&lang=ts"
export * from "./LikeIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports